import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/questions", form); setSent(true); toast.success("Pertanyaan terkirim"); }
    catch { toast.error("Gagal mengirim"); }
  };
  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-8 py-16">
      <h1 className="display text-5xl md:text-7xl">HUBUNGI KAMI</h1>
      {sent ? (
        <div className="mt-8 border border-[color:var(--border)] p-6">Terima kasih. Kami akan membalas via email/telepon.</div>
      ) : (
        <form onSubmit={submit} className="mt-8 space-y-4">
          <input data-testid="q-name" required placeholder="Nama" className="w-full bg-transparent border border-[color:var(--border)] p-3" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
          <input data-testid="q-email" type="email" required placeholder="Email" className="w-full bg-transparent border border-[color:var(--border)] p-3" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
          <input data-testid="q-phone" placeholder="Telepon (opsional)" className="w-full bg-transparent border border-[color:var(--border)] p-3" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
          <textarea data-testid="q-msg" required rows={5} placeholder="Pertanyaan kamu..." className="w-full bg-transparent border border-[color:var(--border)] p-3" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} />
          <button data-testid="q-submit" className="bg-white text-black px-8 py-3 text-xs tracking-widest">KIRIM</button>
        </form>
      )}
    </div>
  );
}
